import { messages } from './messages';

import type { Organization } from './types';
import type { IntlShape } from 'react-intl';

/** Returns a trimmed organization name, with a localized fallback for null or blank names. */
export const getOrganizationDisplayName = (
	organization: Organization,
	intl: Pick<IntlShape, 'formatMessage'>,
): string => organization.orgName?.trim() || intl.formatMessage(messages.unknownOrganization);
